import React, { useState } from 'react';
import { ReactComponent as Logo } from '../../assets/logo/logo-circle-agrotech.svg';
const TableSell = ({
  malang = [
    {
      date: '1/11/2020',
      sumSale: '100.000.000',
      profitPpn: '30.000.000',
      ppn: '2.500.000',
      shipping: '10.000.000',
      feeShipping: '10.000.000',
      profit: '2.000.000',
    },
    {
      date: '2/11/2020',
      sumSale: '100.000.000',
      profitPpn: '30.000.000',
      ppn: '2.500.000',
      shipping: '10.000.000',
      feeShipping: '10.000.000',
      profit: '2.000.000',
    },
    {
      date: '3/11/2020',
      sumSale: '100.000.000',
      profitPpn: '30.000.000',
      ppn: '2.500.000',
      shipping: '10.000.000',
      feeShipping: '10.000.000',
      profit: '2.000.000',
    },
    {
      date: '4/11/2020',
      sumSale: '100.000.000',
      profitPpn: '30.000.000',
      ppn: '2.500.000',
      shipping: '10.000.000',
      feeShipping: '10.000.000',
      profit: '2.000.000',
    },
    {
      date: '4/11/2020',
      sumSale: '100.000.000',
      profitPpn: '30.000.000',
      ppn: '2.500.000',
      shipping: '10.000.000',
      feeShipping: '10.000.000',
      profit: '2.000.000',
    },
    {
      date: '4/11/2020',
      sumSale: '100.000.000',
      profitPpn: '30.000.000',
      ppn: '2.500.000',
      shipping: '10.000.000',
      feeShipping: '10.000.000',
      profit: '2.000.000',
    },
    {
      date: '4/11/2020',
      sumSale: '100.000.000',
      profitPpn: '30.000.000',
      ppn: '2.500.000',
      shipping: '10.000.000',
      feeShipping: '10.000.000',
      profit: '2.000.000',
    },
    {
      date: '4/11/2020',
      sumSale: '100.000.000',
      profitPpn: '30.000.000',
      ppn: '2.500.000',
      shipping: '10.000.000',
      feeShipping: '10.000.000',
      profit: '2.000.000',
    },
    {
      date: '4/11/2020',
      sumSale: '100.000.000',
      profitPpn: '30.000.000',
      ppn: '2.500.000',
      shipping: '10.000.000',
      feeShipping: '10.000.000',
      profit: '2.000.000',
    },
    {
      date: '4/11/2020',
      sumSale: '100.000.000',
      profitPpn: '30.000.000',
      ppn: '2.500.000',
      shipping: '10.000.000',
      feeShipping: '10.000.000',
      profit: '2.000.000',
    },
    {
      date: '4/11/2020',
      sumSale: '100.000.000',
      profitPpn: '30.000.000',
      ppn: '2.500.000',
      shipping: '10.000.000',
      feeShipping: '10.000.000',
      profit: '2.000.000',
    },
    {
      date: '4/11/2020',
      sumSale: '100.000.000',
      profitPpn: '30.000.000',
      ppn: '2.500.000',
      shipping: '10.000.000',
      feeShipping: '10.000.000',
      profit: '2.000.000',
    },
  ],
}) => {
  const [dataTable, setDataTable] = useState(malang);
  return (
    <div className="flex flex-col py-2">
      <div className="flex flex-col w-full">
        <div className="flex px-12 py-2 items-center">
          <Logo className="w-8 h-8 mr-4" />
          <div className="flex flex-col text-sm text-font-gray">
            <p>Laporan Penjualan</p>
            <p>Periode : Nov 2020</p>
          </div>
        </div>
        <div className="flex flex-col my-2">
          <h2 className="text-font-gray font-semibold">Area Malang</h2>
          <h4 className="text-basic-orange font-semibold text-sm">Malang 1</h4>
        </div>

        <div className="max-h-70 overflow-y-auto flex relative">
          <table className="table-auto">
            <thead>
              <tr className="border-t border-b border-gray-300">
                <th className="py-4">Tanggal</th>
                <th className="py-4">Total Penjualan</th>
                <th className="py-4">Laba+PPN</th>
                <th className="py-4">PPN</th>
                <th className="py-4">Ongkir</th>
                <th className="py-4">Fee Ongkir</th>
                <th className="py-4">Laba Bersih</th>
              </tr>
            </thead>
            <tbody>
              {dataTable.map((dataTables, index) => (
                <tr key={index} className="my-1 text-font-gra">
                  <td className=" text-center text-sm px-5 ">
                    {dataTables.date}
                  </td>
                  <td className=" text-center text-sm px-5 ">
                    {dataTables.sumSale}
                  </td>
                  <td className=" text-center text-sm px-5 ">
                    {dataTables.profitPpn}
                  </td>
                  <td className=" text-center text-sm px-5 ">
                    {dataTables.ppn}
                  </td>
                  <td className=" text-center text-sm px-5 ">
                    {dataTables.shipping}
                  </td>
                  <td className=" text-center text-sm px-5 ">
                    {dataTables.feeShipping}
                  </td>
                  <td className=" text-center text-sm px-5 font-semibold ">
                    {dataTables.profit}
                  </td>
                </tr>
              ))}
              <tr className="text-basic-orange text-sm text-center font-semibold">
                <td>Grand Total : </td>
                <td>3.000.000.000</td>
                <td>300.000.000</td>
                <td>25.000.000</td>
                <td>100.000.000</td>
                <td>20.000.000</td>
                <td>295.000.000</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default TableSell;
